module.exports = __webpack_public_path__ + "static/img/dimension_img.90433f47.png";